import { render, staticRenderFns } from "./habitats.vue?vue&type=template&id=5534ec54&"
import script from "./habitats.vue?vue&type=script&lang=js&"
export * from "./habitats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports